import { Button, ButtonType, FormattedMessage } from '@snapchat/snap-design-system-marketing';
import type { Dispatch, FC, SetStateAction } from 'react';

interface BitmojiReactionToggle {
  hideBitmoji: boolean;
  avatarId: string;
  setHideBitmoji: Dispatch<SetStateAction<boolean>>;
}

export const BitmoReactionToggle: FC<BitmojiReactionToggle> = ({
  hideBitmoji,
  setHideBitmoji,
  avatarId,
}) => {
  const hideBitmojiClickHandler = () => {
    setHideBitmoji(!hideBitmoji);
  };

  const getBitmojiToggleText = () => {
    if (hideBitmoji && !avatarId) {
      return <FormattedMessage id="showReactions" defaultMessage="Show Reactions" />;
    }

    if (!hideBitmoji && !avatarId) {
      return <FormattedMessage id="hideReactions" defaultMessage="Hide Reactions" />;
    }

    if (hideBitmoji) {
      return <FormattedMessage id="show" defaultMessage="Show" />;
    }

    return <FormattedMessage id="hide" defaultMessage="Hide" />;
  };

  return (
    <Button
      type={ButtonType.Flat}
      iconName={hideBitmoji ? 'show' : 'hide'}
      onClick={hideBitmojiClickHandler}
    >
      {getBitmojiToggleText()}
    </Button>
  );
};
